// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"352de729","155":"7f043f96","329":"4cd5baa1","567":"2c9f04d3"}[chunkId] + ".chunk.js";
};